<template>
  <q-list>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          By enrolling, I agree to receive my bills, all documents regarding my service, and all other communications to
          the email address provided during this enrollment. I agree that I have provided 4Change Energy with a valid
          email address and understand that I will not receive any bills via regular postal mail. I have read,
          understand and accept the
          <a href="https://www.4changeenergy.com/Docs/4change-enroll_e-Sign-consent_06-2016.pdf" target="_blank" class="cp-non-link" style="text-decoration: none">
            e-Docs Disclosures and Consent
          </a>.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_2" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I authorize 4Change Energy to act as my agent to perform the tasks necessary to switch, establish, or change
          my electric service to 4Change Energy. I have read, understand and accept my Plan Documents (EFL, TOSA and
          YRAC) and the
          <a href="https://www.4changeenergy.com/Docs/4CE_enrollment-disclosures_06-2016.pdf" target="_blank" class="cp-non-link">
            Enrollment Disclosures and Consent
          </a>.
        </q-item-label>
      </q-item-section>
    </q-item>

  </q-list>
</template>

<script>
import { watch, ref } from "vue";
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";

export default {
  name: "FourChangeAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { selected_plan } = SelectedPlan();
    const { plan_brand } = Utilities();
    const authorizations = ref([]);
    watch(authorizations, () => {
      const agreed = authorizations.value.length === 2
      emit('update:modelValue', agreed);
    })
    return {
      authorizations,
      selected_plan,
      plan_brand
    }
  }
}
</script>

<style scoped>

</style>
